import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var fileService;
export default function () {

    var FileModel = Model.extend({
        className: "ReportCommentsFiles",
        defaults: {
            'manualTitle': false,
        },
    });

    var FileCollection = Collection.extend({
        model: FileModel,
    });
    var FileService = ParseService.extend({
        sortBy: 'createdAt',
        itemsOnPage: 100, // load by N items, this overrides the 1k limit 'parseService.js'
        model: FileModel,
        collection: FileCollection,
		createSimpleFile:function(file, reportID,reportcommentID,xl){
			var ReportCommentFile = Parse.Object.extend("Files");
			var reportCommentFile = new ReportCommentFile();
			reportCommentFile.set("file",file);
			reportCommentFile.set('report',{__type: "Pointer", className: "Report", objectId: reportID});
      		reportCommentFile.set('comment',{__type: "Pointer", className: "ReportComments", objectId: reportcommentID})
			reportCommentFile.save(null, {
				success: function(reportComment) {
					xl(reportComment, true);
				},
				error: function(reportComment, error) {
					console.log(error);
          xl(reportComment, false);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
			        break;
            default:
              toastr.error("A file has an invalid file extension. Not Uploaded",'Error');
              break;
					}
				}
			});
		},
    });

    return fileService || (fileService = new FileService());
};
// only created once for application
